import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import MissionPage from "./pages/MissionPage";
import HistoirePage from "./pages/HistoirePage";
import RecherchePage from "./pages/RecherchePage";
import CentrePage from "./pages/CentrePage";
import ProgrammePage from "./pages/ProgrammePage";
import ScientifiquesPage from "./pages/ScientifiquesPage";
import PartenariatsPage from "./pages/PartenariatsPage";
import FeuilleDeRoutePage from "./pages/FeuilleDeRoutePage";
import SoutenirPage from "./pages/SoutenirPage";
import ActualitesPage from "./pages/ActualitesPage";
import RessourcesPage from "./pages/RessourcesPage";
import TransparencePage from "./pages/TransparencePage";
import ContactPage from "./pages/ContactPage";
import AssociationPage from "./pages/AssociationPage";
import EvenementsPage from "./pages/EvenementsPage";
import ProjetsPage from "./pages/ProjetsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPage from "./pages/AdminPage";
import { MentionsLegalesPage, ConfidentialitePage, NotFoundPage } from "./pages/LegalPages";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <ReactLenis root options={{ lerp: 0.09, duration: 1.15 }}>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/association" element={<AssociationPage />} />
                <Route path="/evenements" element={<EvenementsPage />} />
                <Route path="/projets" element={<ProjetsPage />} />
                <Route path="/mission" element={<MissionPage />} />
                <Route path="/histoire" element={<HistoirePage />} />
                <Route path="/recherche" element={<RecherchePage />} />
                <Route path="/centre" element={<CentrePage />} />
                <Route path="/programme" element={<ProgrammePage />} />
                <Route path="/scientifiques" element={<ScientifiquesPage />} />
                <Route path="/partenariats" element={<PartenariatsPage />} />
                <Route path="/feuille-de-route" element={<FeuilleDeRoutePage />} />
                <Route path="/soutenir" element={<SoutenirPage />} />
                <Route path="/actualites" element={<ActualitesPage />} />
                <Route path="/ressources" element={<RessourcesPage />} />
                <Route path="/transparence" element={<TransparencePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
                <Route path="/confidentialite" element={<ConfidentialitePage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  borderRadius: 0,
                  background: "#1A1D1C",
                  color: "#FFFFFF",
                  border: "1px solid rgba(255,255,255,0.12)",
                  fontFamily: "'IBM Plex Sans', sans-serif",
                },
              }}
            />
          </div>
        </BrowserRouter>
      </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
